'use client';

import { createContext, useContext, useState, useCallback } from 'react';
import type { SessionData } from './api-types';

interface SessionContextValue {
  session: SessionData;
  updateSession: (data: SessionData) => void;
  clearSession: () => void;
}

const defaultSession: SessionData = { loggedIn: false, userName: '', cartCount: 0 };

const SessionContext = createContext<SessionContextValue>({
  session: defaultSession,
  updateSession: () => {},
  clearSession: () => {},
});

export function SessionProvider({
  initial,
  children,
}: {
  initial: SessionData | null;
  children: React.ReactNode;
}) {
  const [session, setSession] = useState<SessionData>(initial ?? defaultSession);
  const updateSession = useCallback((data: SessionData) => setSession(data), []);
  const clearSession = useCallback(() => setSession(defaultSession), []);

  return (
    <SessionContext.Provider value={{ session, updateSession, clearSession }}>
      {children}
    </SessionContext.Provider>
  );
}

export function useSession() {
  return useContext(SessionContext);
}
